import { render, staticRenderFns } from "./basicPieChart.vue?vue&type=template&id=7638c3b8&"
import script from "./basicPieChart.vue?vue&type=script&lang=js&"
export * from "./basicPieChart.vue?vue&type=script&lang=js&"
import style0 from "./basicPieChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports